import React from 'react'

import Modal from '../../../UI/Modal/Modal'
import Body from './Body/Body'
import Footer from './Footer/Footer'
import { withTranslate } from 'react-redux-multilingual'

const delegateModal = ({
  delegateData,
  open,
  cancelled,
  submitted,
  inputChanged,
  cancelDelegateChanged,
  addClicked,
  deleteRowClicked,
  dropdownOptions,
  currentCompany,
  delegateForm,
  translate
}) => {
  return (
    <Modal
      open={open}
      backdropClicked={cancelled}
      onHide={cancelled}
      header={translate('delegate')}
      size={'xl'}
      footer={<Footer saveClicked={submitted} cancelClicked={cancelled} />}>
      <Body
        inputChanged={inputChanged}
        data={delegateData}
        addRowClicked={addClicked}
        deleteRowClicked={deleteRowClicked}
        dropdownOptions={dropdownOptions}
        currentCompany={currentCompany}
        cancelDelegateChanged={cancelDelegateChanged}
        delegateForm={delegateForm}
      />
    </Modal>
  )
}

export default withTranslate(delegateModal)
